import * as m from "./../../dist/es2015/percent.js";
export const am5percent = m;